import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Container from '../../layout/Container';
import Loading from '../../misc/Loading';
import NotFound from '../../misc/NotFound';
import Notice from '../../misc/Notice';

function Response({ errors, hasLoaded, children }) {
  const { t } = useTranslation();

  if (errors.some((error) => error.status === 404)) {
    return (
      <Container>
        <NotFound />
      </Container>
    );
  }

  if (errors.some((error) => error.request && error.request.status === 404)) {
    return (
      <Container>
        <NotFound />
      </Container>
    );
  }

  if (errors.some((error) => error.messages.size > 0)) {
    return (
      <Container>
        {errors.map((error) => {
          return error.messages?.map((message, index) => (
            <Notice key={index} type={message.type}>
              {message.message}
            </Notice>
          ));
        })}
      </Container>
    );
  }

  if (!hasLoaded) {
    return (
      <Container>
        <Loading inline={true} text={t('styleguide:forms.loading')} />
      </Container>
    );
  }

  return children;
}

Response.propTypes = {
  /**
   * The errors
   */
  errors: PropTypes.array,
  /**
   * The loaded flag
   */
  hasLoaded: PropTypes.bool,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default Response;
